requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded(['cart.js'], () => {
      if (!customElements.get('product-form-group')) {
        customElements.define('product-form-group', class ProductForms extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.buttons = this.querySelectorAll('.product-form-group__button');
            this.onButtonClickHandler = this.onButtonClick.bind(this);
            this.buttons.forEach(button => button.addEventListener('click', this.onButtonClickHandler));
          }

          disconnectedCallback() {
            this.buttons.forEach(button => button.removeEventListener('click', this.onButtonClickHandler));
          }

          toggleLoadingButton(isLoading) {
            this.buttons.forEach(button => {
              button[isLoading ? 'setAttribute' : 'removeAttribute']('aria-disabled', true);
              button.classList.toggle('loading', isLoading);
            });
          }

          onButtonClick(event) {
            event.preventDefault();
            this.jsonData = this.jsonData || JSON.parse(document.getElementById(this.dataset.jsonId).textContent);
            const body = new FormData();
            this.jsonData.forEach((item, index) => {
              body.append(`items[${index}][id]`, item.id);
              body.append(`items[${index}][quantity]`, item.quantity);
            });

            cartBase.addToCart({
              body,
              target: this,
              onLoadingToggle: (isLoading) => {
                this.toggleLoadingButton(isLoading);
                cartBase.toggleCartLoading({
                  isLoading
                });
              }
            });
          }

          onError(errors) {
            document.querySelector('push-messages')?.push(errors);
          }
        });

        scriptController.scripts.push('product-form-group.js');
      }
    });
  });
});